import { render, staticRenderFns } from "./airlineProductVoyage.vue?vue&type=template&id=58320c7e&scoped=true&"
import script from "./airlineProductVoyage.vue?vue&type=script&lang=js&"
export * from "./airlineProductVoyage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58320c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58320c7e')) {
      api.createRecord('58320c7e', component.options)
    } else {
      api.reload('58320c7e', component.options)
    }
    module.hot.accept("./airlineProductVoyage.vue?vue&type=template&id=58320c7e&scoped=true&", function () {
      api.rerender('58320c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyage.vue"
export default component.exports